import React, { useContext } from 'react'
import { useTheme } from '@emotion/react'
import PropTypes from 'prop-types'
import { StyleSheet, css } from 'aphrodite/no-important'
import { ThemeContext } from '../theme'

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  sticky: PropTypes.bool
}

const defaultProps = { sticky: false }

const Navbar = (props) => {
  const context = useContext(ThemeContext)
  const theme = useTheme()
  let navbar
  if (theme && theme.navbar) {
    navbar = theme.navbar
  } else {
    navbar = context.theme.navbar
  }
  const {
    navbarSeparatorHeight: sepHeight,
    navbarColor,
    navbarBackground,
    navbarSeparatorColor
  } = navbar

  const styles = StyleSheet.create({
    navbar: {
      display: 'flex',
      width: '100vw',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0',
      paddingLeft: '0px',
      background: navbarBackground,
      color: navbarColor,
      borderBottom: `${sepHeight} solid ${navbarSeparatorColor}`,
      position: props.sticky ? 'fixed' : '',
      top: props.sticky ? '0' : '',
      '@media (max-width: 479px)': {
        paddingLeft: '0px'
      }
    }
  })

  return (
    <nav className={`qtxui-navbar ${props.className} ${css(styles.navbar)}`}>
      {props.children}
    </nav>
  )
}

Navbar.propTypes = propTypes
Navbar.defaultProps = defaultProps
export { Navbar }
